


import authorizedAxios from "../../helpers/authorizedAxios";
export const SET_BEST_SELLING_PRODUCT = "SET_BEST_SELLING_PRODUCT";
export const SET_BEST_SELLING_PRODUCT_LOADING = "SET_BEST_SELLING_PRODUCT_LOADING";
export const SET_BEST_SELLING_PRODUCT_ERROR = "SET_BEST_SELLING_PRODUCT_ERROR";
export const SET_DASHBOARD_OVERVIEW = "SET_DASHBOARD_OVERVIEW";
export const SET_SOLD_PRODUCT_DETAIL = "SET_SOLD_PRODUCT_DETAIL";
export const SET_SOLD_PRODUCT_DETAIL_LOADING = "SET_SOLD_PRODUCT_DETAIL_LOADING";
export const SET_SOLD_PRODUCT_DETAIL_ERROR = "SET_SOLD_PRODUCT_DETAIL_ERROR";
export const SET_DASHBOARD_MATERIAL_USAGE = "SET_DASHBOARD_MATERIAL_USAGE";
export const SET_DASHBOARD_MATERIAL_USAGE_LOADING = "SET_DASHBOARD_MATERIAL_USAGE_LOADING";
export const SET_DASHBOARD_MATERIAL_USAGE_ERROR = "SET_DASHBOARD_MATERIAL_USAGE_ERROR";
export const SET_DASHBOARD_PROFIT_DETAIL = "SET_DASHBOARD_PROFIT_DETAIL";
export const SET_DASHBOARD_PROFIT_DETAIL_LOADING = "SET_DASHBOARD_PROFIT_DETAIL_LOADING";
export const SET_DASHBOARD_PROFIT_DETAIL_ERROR = "SET_DASHBOARD_PROFIT_DETAIL_ERROR";

const overviewRequests = new WeakMap();
const profitDetailRequests = new WeakMap();
const soldProductRequests = new WeakMap();

export const fetchDashboardOverview = (startDate, endDate, groupBy = "day") => {
  return async (dispatch) => {
    const request = {};
    overviewRequests.set(dispatch, request);
    dispatch({ type: SET_BEST_SELLING_PRODUCT_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/dashboard", {
        params: {
          start_date: startDate,
          end_date: endDate,
          group_by: groupBy
        }
      });

      if (overviewRequests.get(dispatch) !== request) return null;
      dispatch({
        type: SET_DASHBOARD_OVERVIEW,
        data: response?.data?.data
      });
      return response?.data?.data;
    } catch (error) {
      if (overviewRequests.get(dispatch) !== request) return null;
      dispatch({
        type: SET_BEST_SELLING_PRODUCT_ERROR,
        error: error?.response?.data?.message || "Terjadi kesalahan saat mengambil dashboard."
      });
      return null;
    } finally {
      if (overviewRequests.get(dispatch) === request) dispatch({ type: SET_BEST_SELLING_PRODUCT_LOADING, status: false });
    }
  };
};

export const fetchDashboardProfitDetails = (type, startDate, endDate, page = 1) => async (dispatch) => {
  const request = {};
  profitDetailRequests.set(dispatch, request);
  dispatch({ type: SET_DASHBOARD_PROFIT_DETAIL_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/dashboard/profit-details", {
      params: { type, start_date: startDate, end_date: endDate, page },
    });
    if (profitDetailRequests.get(dispatch) !== request) return null;
    dispatch({ type: SET_DASHBOARD_PROFIT_DETAIL, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    if (profitDetailRequests.get(dispatch) !== request) return null;
    dispatch({ type: SET_DASHBOARD_PROFIT_DETAIL_ERROR, error: error?.response?.data?.message || "Rincian laba belum dapat dimuat. Silakan coba lagi." });
    return null;
  } finally {
    if (profitDetailRequests.get(dispatch) === request) dispatch({ type: SET_DASHBOARD_PROFIT_DETAIL_LOADING, status: false });
  }
};

export const fetchBestSellingProduct = (start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_BEST_SELLING_PRODUCT_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(
        "/dashboard/best-selling-products?start_date=" + start_date + "&end_date=" + end_date
      );

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_BEST_SELLING_PRODUCT,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_BEST_SELLING_PRODUCT_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_BEST_SELLING_PRODUCT_LOADING, status: false });
    }
  };
};

export const fetchSoldProductDetail = (productId, startDate, endDate) => {
  return async (dispatch) => {
    const request = {};
    soldProductRequests.set(dispatch, request);
    dispatch({ type: SET_SOLD_PRODUCT_DETAIL_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(`/dashboard/sold-products/${productId}`, {
        params: { start_date: startDate, end_date: endDate },
      });
      if (soldProductRequests.get(dispatch) !== request) return null;
      dispatch({ type: SET_SOLD_PRODUCT_DETAIL, data: response?.data?.data || null });
      return response?.data?.data || null;
    } catch (error) {
      if (soldProductRequests.get(dispatch) !== request) return null;
      dispatch({
        type: SET_SOLD_PRODUCT_DETAIL_ERROR,
        error: error?.response?.data?.message || "Detail produk terjual belum dapat dimuat.",
      });
      return null;
    } finally {
      if (soldProductRequests.get(dispatch) === request) dispatch({ type: SET_SOLD_PRODUCT_DETAIL_LOADING, status: false });
    }
  };
};

export const clearSoldProductDetail = () => (dispatch) => {
  soldProductRequests.delete(dispatch);
  dispatch({ type: SET_SOLD_PRODUCT_DETAIL, data: null });
  dispatch({ type: SET_SOLD_PRODUCT_DETAIL_LOADING, status: false });
};

export const fetchDashboardMaterialUsage = ({
  startDate,
  endDate,
  category = "all",
  unit = "all",
  groupBy = "material",
  drillDownCategory = "",
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_DASHBOARD_MATERIAL_USAGE_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/dashboard/material-usage", {
        params: {
          start_date: startDate,
          end_date: endDate,
          category,
          unit,
          group_by: groupBy,
          drill_down_category: drillDownCategory || undefined,
        },
      });
      const data = response?.data?.data || null;
      dispatch({ type: SET_DASHBOARD_MATERIAL_USAGE, data });
      return data;
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_MATERIAL_USAGE_ERROR,
        error: error?.response?.data?.message || "Pemakaian material belum dapat dimuat.",
      });
      return null;
    } finally {
      dispatch({ type: SET_DASHBOARD_MATERIAL_USAGE_LOADING, status: false });
    }
  };
};
